<div class="form-field has-suffix" [class.has-error]="showError">
  @if (label) {
    <label>{{ label }}</label>
  }
  @if (suffixIcon && (type === 'text' || type === 'password' || type === 'datepicker')) {
    <div class="input-wrapper">
      @if (type === 'text' || type === 'password') {
        @if (type === 'text' || type === 'password') {
          <input
            [type]="type"
            [placeholder]="placeholder"
            [ngModel]="value"
            (ngModelChange)="onChange($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            [disabled]="isDisabled"
          />
        }
        @if (suffixIcon) {
          <span class="suffix-icon" (click)="suffixIconClick.emit()">
            <ui-svg-icon [svgIcon]="suffixIcon" size="large" />
          </span>
        }
      }
      @if (type === 'datepicker') {
        <input
          matInput
          [placeholder]="placeholder"
          [value]="value"
          (dateChange)="onDateChange($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
          [disabled]="isDisabled"
          readonly="true"
          [matDatepicker]="picker"
          [min]="minDate"
          (click)="picker.open()"
          class="datepicket-input"
        />
        @if (value) {
          <span class="clear-datepicker" (click)="clearDatePicker($event)">
            <ui-svg-icon svgIcon="close-cc" size="large" />
          </span>
        }
        <span class="suffix-icon" (click)="picker.open()">
          <ui-svg-icon svgIcon="calendar" size="large" />
        </span>
        <mat-datepicker #picker />
      }
    </div>
  }
  @if (!suffixIcon) {
    @if (type === 'text' || type === 'password') {
      <input
        [type]="type"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
      />
    }
    @if (type === 'textarea') {
      <textarea
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
        autocomplete="off"
        rows="4"
      ></textarea>
    }
    @if (type === 'select') {
      <select
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
      >
        @for (option of options; track option) {
          <option [ngValue]="option.value">
            {{ option.label | translate }}
          </option>
        }
      </select>
    }
  }

  @if (showError) {
    <div class="error">
      @for (error of errors; track error) {
        <small>{{ error }}</small>
      }
    </div>
  }
</div>
